import styled from '../../styled-components';

export const Pin = styled.div`
  > svg {
    width: auto;
    height: 35px;
  }
`;
